import { HttpClient } from '@angular/common/http';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-visitor-register',
  templateUrl: './visitor-register.component.html',
  styleUrls: ['./visitor-register.component.css']
})
export class VisitorRegisterComponent implements OnInit {

  
  contactForm={
    name:'',
    nameE:false,
    email:'',
    emailE:false,
    phone:'',
    phoneE:false,
    company:'',
    companyE:false,
    heardUs: [],
    headerUsError:false,
    other: '',
    otherError:false,
    agreeTnc: false,
    
  }

  @ViewChildren('chkboxes') chkboxes: QueryList<any>;
  constructor(
    private toast: ToastrService,
    private http: HttpClient,
    private firestore: AngularFirestore,
  ) { }

  ngOnInit() {
  }

  flag = false;

  onChange(event){
    let index = this.contactForm.heardUs.findIndex(e=> e === event);

    if(index < 0 ){
      this.contactForm.heardUs.push(event)
    }else{
      this.contactForm.heardUs.splice(index, 1)
    }

    this.flag = this.contactForm.heardUs.some(e=>e === 'Others');
  }

  valid(){
    return !this.contactForm.nameE && !this.contactForm.emailE && 
    !this.contactForm.phoneE && !this.contactForm.companyE && !this.contactForm.headerUsError

  }

  send(){
    this.contactForm.nameE = this.validate(this.contactForm.name);
    this.contactForm.emailE = this.validateEmail(this.contactForm.email);
    this.contactForm.phoneE = this.validatePhone(this.contactForm.phone);
    this.contactForm.companyE = this.validate(this.contactForm.company);
    this.contactForm.headerUsError = this.contactForm.heardUs.length === 0;
    this.contactForm.otherError = this.validate(this.contactForm.other);
    
    if(!this.valid()){
      this.toast.error("Please make sure the form is filled in correct value")
      return;
    }

    if(this.contactForm.heardUs.some(e=> e === 'Others') && this.contactForm.otherError){
      this.toast.error("Please make sure the form is filled in correct value")
      return;
    }

    this.firestore.collection('VisitorRegister').add({
      ...this.contactForm,
      visitorDate: new Date()
    }).then(e=>{
      this.toast.success("Register successful")
      this.contactForm={
        name:'',
        nameE:false,
        email:'',
        emailE:false,
        phone:'',
        phoneE:false,
        company:'',
        companyE:false,
        heardUs: [],
        headerUsError:false,
        other: '',
        otherError:false,
        agreeTnc: false,
      }
      this.chkboxes.forEach(x => x.checked = false);
    })


  }

  validateEmail(value) {
    if ((/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(value))) {
      return false;
    }
    return true;
  }
  validatePhone(value) {
    if (value.length > 8 && value.length < 20) {
      return false;
    }
    return true;
  }

  validate(value) {
    if (!value) {
      return true;
    }
    return false;
  }

}
